/* [NOM DE MARQUE] - theme.js
   - reveal-on-scroll
   - mobile menu toggle
   - sticky ATC visibility
   - cart count refresh
   - horizontal scroll dots (mobile)
*/
(function () {
  'use strict';

  // Reveal on scroll
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      }),
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    reveals.forEach((el) => io.observe(el));
  }

  // Header scroll state (used for transparent header on the homepage)
  const header = document.querySelector('.header');
  if (header) {
    const updateHeaderState = () => {
      if (window.scrollY > 20) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  }

  // Mobile menu toggle
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    const nav = document.querySelector('[data-header-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  // Cart count refresh
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = data.item_count;
        el.hidden = data.item_count === 0;
      });
    } catch (err) { /* silent */ }
  }
  window.theme = window.theme || {};
  window.theme.refreshCart = refreshCart;
  document.addEventListener('DOMContentLoaded', refreshCart);

  // Sticky ATC visibility
  const sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) {
    const trigger = document.querySelector('[data-sticky-trigger]') || document.querySelector('.product-buy');
    if (trigger) {
      const io2 = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) sticky.classList.add('is-visible');
          else sticky.classList.remove('is-visible');
        },
        { threshold: 0 }
      );
      io2.observe(trigger);
    }
  }

  // Horizontal scroll dots — auto-init for [data-scroll-x]
  function initScrollDots(container) {
    if (!container || container.dataset.dotsInit) return;
    const dotsTarget = container.parentElement.querySelector('[data-scroll-dots]');
    if (!dotsTarget) return;
    const items = Array.from(container.children);
    if (items.length < 2) return;

    dotsTarget.innerHTML = '';
    const dots = items.map((_, i) => {
      const dot = document.createElement('span');
      dot.className = 'scroll-hint__dot' + (i === 0 ? ' is-active' : '');
      dotsTarget.appendChild(dot);
      return dot;
    });

    let raf = null;
    container.addEventListener('scroll', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        // Find item whose left edge is closest to the container's scroll position
        const cRect = container.getBoundingClientRect();
        let bestIdx = 0;
        let bestDist = Infinity;
        items.forEach((item, i) => {
          const iRect = item.getBoundingClientRect();
          const dist = Math.abs(iRect.left - cRect.left);
          if (dist < bestDist) { bestDist = dist; bestIdx = i; }
        });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === bestIdx));
      });
    }, { passive: true });

    container.dataset.dotsInit = '1';
  }

  function initAllScrollDots() {
    document.querySelectorAll('[data-scroll-x]').forEach(initScrollDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllScrollDots);
  } else {
    initAllScrollDots();
  }
  // Re-init on Shopify section render (theme editor)
  document.addEventListener('shopify:section:load', initAllScrollDots);

  window.theme.initScrollDots = initScrollDots;
})();
